<!-- 家长监护 -->
<template>
  <div class="content">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "Parents",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("initTabName", "parents");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  width: 1000px;
  margin:0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Parents.vue